// ********************************************************
// Wheel Loader
// Handles stuff like view and submit weights from wheel loader.
// ********************************************************

import * as Backend from '@/core/backend'

export async function loadRegistrations (params) {
  const res = await Backend.callApi({
    apiName: 'WheelLoader.LoadRegistrations',
    inputData: {
      Facility: params
    }
  })
  if (!res.failed && res.data !== null) {
    // Sort so newest is top-most
    res.data = res.data.sort((a, b) =>
      (a.CreatedData < b.CreatedData) ? 1 : ((b.CreatedData < a.CreatedData) ? -1 : 0))
  }
  return res
}

export async function loadRegistration (id) {
  const res = await Backend.callApi({
    apiName: 'WheelLoader.LoadRegistration',
    inputData: {
      Id: id
    }
  })
  return res
}

export async function loadFacilityData (params) {
  const res = await Backend.callApi({
    apiName: 'WheelLoader.LoadFacilityData',
    inputData: {
      FacilityNo: params.facilityNo,
      CorpName: params.corpName
    }
  })
  return res
}

export async function saveRegistration (registration, saveOnlyComment = false) {
  const res = await Backend.callApi({
    apiName: 'WheelLoader.SaveRegistration',
    inputData: {
      Registration: registration,
      SaveOnlyComment: saveOnlyComment
    }
  })
  return res
}

export async function printRegistration (id) {
  const res = await Backend.callApi({
    apiName: 'WheelLoader.PrintRegistration',
    inputData: {
      Id: id
    }
  })
  return res
}

export async function getWeight (params) {
  const res = await Backend.callApi({
    apiName: 'WheelLoader.GetWeight',
    inputData: {
      VT25Id: params.VT25Id,
      ResetWeight: params.ResetWeight
    }
  })
  return res
}

export async function uploadWeight (params) {
  const res = await Backend.callApi({
    apiName: 'WheelLoader.UploadWeight',
    inputData: {
      VT25Id: params.VT25Id,
      Wk60WeightData: params.Wk60WeightData
    }
  })
  return res
}

export async function getCurrentWeightIds (params) {
  const res = await Backend.callApi({
    apiName: 'WheelLoader.GetCurrentWeightIds',
    inputData: {
      Id: params
    }
  })
  return res
}

export async function loadVehicles (param) {
  const res = await Backend.callApi({
    apiName: 'Archive.LoadVehicles',
    inputData: {
      // MITH special: If facility is '' show all vehicles for all facilities (we use facility = null).
      Facility: param.facility === '' ? null : param.facility,
      SearchText: param.searchText,
      LoadDeleted: false // never load Deleted
    }
  })
  return res
}

export async function loadFilteredArticles (params) {
  const res = await Backend.callApi({
    apiName: 'Archive.LoadArticles',
    inputData: {
      Facility: params.facilityNo,
      ArticleNoFilter: params.ArticleNoFilter
    }
  })
  return res
}
